module.exports = __webpack_public_path__ + "img/TW.4409fe32.png";